import React, {FC, useState, useEffect, useContext} from "react"
import {CodeContext} from "@irati/deals/context"
import copyStatic from "@irati/ui/images/copy_static.svg"
import {FormattedMessage} from "@irati/utils/lang"
import mainTheme from "@irati/ui/src/global/theme"
import copySuccessful from "@irati/ui/images/copy_successful.svg"
import {Label} from "@irati/ui/src/Typography"
import CopyToClipboard from "react-copy-to-clipboard"
import {Voucher} from "@irati/deals/types"
import {CopyCodeButton, Image} from "./styled/Code"

interface Props {
  voucher: Voucher
}

export const COUNTDOWN_INITIAL_COPY_CODE_STATE = 5000
export const COUNTDOWN_COPY_CODE_STATE = 3000

const DealSuccessCopyCodeButton: FC<Props> = ({voucher}) => {
  const context = useContext(CodeContext)

  const [showButton, setShowButton] = useState<boolean>(true)
  useEffect(() => {
    if (context.shouldAutoOpenLink) {
      setShowButton(false)
      setTimeout(() => {
        setShowButton(true)
      }, COUNTDOWN_INITIAL_COPY_CODE_STATE)
    } else {
      setShowButton(true)
    }
  }, [])

  const showCopyButton = () => {
    setShowButton(false)
    setTimeout(() => {
      setShowButton(true)
    }, COUNTDOWN_COPY_CODE_STATE)
  }

  if (showButton) {
    return (
      <CopyToClipboard text={voucher.code}>
        <CopyCodeButton onClick={showCopyButton}>
          <Image src={copyStatic} />
          <FormattedMessage id="perks.components.tickets.ticket.copyButton.code" />
        </CopyCodeButton>
      </CopyToClipboard>
    )
  }

  return (
    <Label color={mainTheme.colors.primary1} large>
      <Image src={copySuccessful} />
      <FormattedMessage id="perks.components.tickets.ticket.code.copiedMessage" />
    </Label>
  )
}

export default DealSuccessCopyCodeButton
